import { parseQuery } from '@calendly/http-tools'

/**
 * Returns true when the given `messageOrigin` matches the `embed_domain` query
 * parameter on the iframe URL.
 *
 * This is the shared trust check for parent ↔ iframe consent messaging: the
 * embedding host advertises its domain via the `embed_domain` query param that
 * widget.js appends to the iframe URL, and we only accept (or respond to)
 * messages whose `MessageEvent.origin` host matches that value.
 *
 * @param {string} search window.location.search of the iframe
 * @param {string|null|undefined} messageOrigin MessageEvent.origin
 * @returns {boolean}
 */
export const embedParentOriginMatchesMessage = (search, messageOrigin) => {
  const { embed_domain: embedDomain } = parseQuery(search)
  if (!embedDomain || !messageOrigin) return false
  try {
    return new URL(messageOrigin).host === embedDomain
  } catch {
    return false
  }
}
